export default __webpack_public_path__ + "static/EDUbox-co-op-game-7bef7a0468a2605def6c6900a57a5cf8.png";